import React, { useEffect, createElement } from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { RealitySection } from './sections/RealitySection';
import { ExampleSection } from './sections/ExampleSection';
import { SolutionSection } from './sections/SolutionSection';
import { BenefitsSection } from './sections/BenefitsSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { UrgencySection } from './sections/UrgencySection';
import { OfferSection } from './sections/OfferSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Reducí Tu Factura de Luz | Ahorro Total';
    // Meta Pixel
    if (!(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1260965482133500');
      f.fbq('track', 'PageView');
      // noscript fallback
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1260965482133500&ev=PageView&noscript=1';
      document.body.appendChild(img);
    }
  }, []);
  return <div className="w-full min-h-screen bg-brand-darker font-body" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <RealitySection data-id="element-3" />
      <ExampleSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <UrgencySection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FinalCTASection data-id="element-10" />
      <SocialProofPopup data-id="element-11" />
    </div>;
}